import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useEffect } from 'react';
import { Lock, SavingBankCash } from '@zooplus/icons';
import { FormFieldWrap, Input } from '@zooplus/ui-components';
import Message from '../../../components/Message/Message.js';
import { useTranslation } from '../../../hooks/useTranslations.js';
import { useFormContext } from '../../../providers/FormContextProvider.js';
import { persistCursorPosForSpacedInputValue } from '../../../utils/cardUtils.js';
import styles from './SepaForm.module.scss.js';

const SepaForm = () => {
    const { t } = useTranslation();
    const { setFormData, getFormData, initForm, clearForm } = useFormContext();
    useEffect(() => {
        initForm('sepa');
        return () => {
            clearForm();
        };
    }, []);
    const iban = getFormData('sepa', 'iban');
    const holderName = getFormData('sepa', 'holderName');
    return (jsxs(Fragment, { children: [jsxs("div", { className: classNames(styles.formMessageContainer, styles.margin), children: [jsx(Message, { size: "s", className: styles.formMessage, text: t('checkout.general.payment.directdebit.securityInfo'), icon: jsx(Lock, {}) }), jsx(Message, { size: "s", className: styles.formMessage, text: t('checkout.general.payment.directdebit.bankInfo'), icon: jsx(SavingBankCash, {}) })] }), jsx(FormFieldWrap, { className: styles.margin, isRequired: true, labelText: "Cardholder Name", errorMessage: holderName.hasError && t('checkout.payment.sepaForm.error.form.holderName.invalid'), children: jsx(Input, { "data-zta": "holderNameInput", onChange: (e) => setFormData('sepa', 'holderName', e.target.value), hasError: holderName.hasError, inputProps: {
                        defaultValue: holderName.value,
                        placeholder: 'Kim Mustermensch',
                        maxLength: 30,
                    } }) }), jsx(FormFieldWrap, { className: styles.margin, isRequired: true, labelText: "IBAN", errorMessage: iban.hasError && t('checkout.payment.sepaForm.error.form.iban.invalid'), children: jsx(Input, { "data-zta": "ibanInput", onChange: (e) => {
                        setFormData('sepa', 'iban', persistCursorPosForSpacedInputValue(e.target));
                    }, hasError: iban.hasError, inputProps: {
                        defaultValue: iban.value,
                        placeholder: '**** **** **** **** ****',
                        className: 'formField',
                        maxLength: 42,
                        /**
                         * Maximum number of characters on an IBAN can go up to 34,
                         * accounting for spaces every 4 characters the maximum would be 42 for our input
                         * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number#Structure
                         */
                    } }) })] }));
};

export { SepaForm as default };
//# sourceMappingURL=SepaForm.js.map
